import {Injectable} from '@angular/core';
import {MiscellaneousSiteForm, SubscriptionSiteForm} from '../models/site-form';
import {SubscriptionI} from '../../shared/models/subscription-i';
import {Site} from '../../shared/models/site';
import {select, Store} from '@ngrx/store';
import * as fromSite from '../reducers';
import {filter} from 'rxjs/operators';
import * as _ from 'lodash';
import {Observable} from 'rxjs';
import {DateFormatService} from '../../shared/services/date-format.service';
import {Culture} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class SiteMapperService {
  currentSite$: Observable<Site>;
  currentSubscription: SubscriptionI;

  constructor(private store: Store<fromSite.AppState>, private dateFormatService: DateFormatService) {
    this.currentSite$ = this.store.pipe(select(fromSite.selectors.getSite), filter(site => !_.isEmpty(site)));
    this.currentSite$.subscribe((site: Site) => {
      this.currentSubscription = site.subscriptions ? site.subscriptions[0] : null;
    });
  }



  subscriptionDbToForm(subForm: Site): SubscriptionSiteForm {
    return {
      site: {
        displayName: subForm.displayName,
        extId: subForm.externalID,
        timezone: {
          id: null,
          name: null,
          ianaCode: subForm.timeZone
        },
      },
      subscription: {
        cultures: subForm.subscriptions[0].cultures,
        name: subForm.subscriptions[0].name,
        isSold: subForm.subscriptions[0].isSold,
        statutoryName: subForm.subscriptions[0].statutoryName,
        service: {
          id: subForm.subscriptions[0] ? subForm.subscriptions[0].service.id : null,
          name: subForm.subscriptions[0] ? subForm.subscriptions[0].service.name : null
        },
        product: {
          id: subForm.subscriptions[0] ? subForm.subscriptions[0].product.id : null,
          name: subForm.subscriptions[0] ? subForm.subscriptions[0].product.name : null
        },
        status: {
          id: subForm.subscriptions[0] ? subForm.subscriptions[0].status : null,
          name: null
        },
        program: {
          id: subForm.subscriptions[0] ? subForm.subscriptions[0].program.id : null,
          name: subForm.subscriptions[0] ? subForm.subscriptions[0].program.name : null
        },
      },
      serverForm: {
        server: {
          id: subForm.subscriptions[0] && subForm.subscriptions[0].server ? subForm.subscriptions[0].server.id : null,
        },
        url: {
          id: subForm.subscriptions[0] && subForm.subscriptions[0].server ? subForm.subscriptions[0].server.url : null
        },
        cms: {
          id: subForm.subscriptions[0] && subForm.subscriptions[0].cmsServerID ? subForm.subscriptions[0].cmsServerID : null
        },
        ip: subForm.subscriptions[0] && subForm.subscriptions[0].server ? subForm.subscriptions[0].server.ip : null,
        name: subForm.subscriptions[0] && subForm.subscriptions[0].server ? subForm.subscriptions[0].server.name : null
      },
      audioOption: {
        licence: {
          id: subForm.subscriptions[0] && subForm.subscriptions[0].licence ? subForm.subscriptions[0].licence.id : null,
          name: subForm.subscriptions[0] && subForm.subscriptions[0].licence ? subForm.subscriptions[0].licence.name : null
        },
        cd: subForm.subscriptions[0] ? subForm.subscriptions[0].cd : null
      },
      videoOption: {
        screenRotation: {
          id: subForm.subscriptions[0] ? subForm.subscriptions[0].screenRotation : null,
          name: subForm.subscriptions[0] ? subForm.subscriptions[0].screenRotation + '' : null,
        }
      }
    }
  }

  miscellaneousDbToForm(siteForm: Site): MiscellaneousSiteForm {
    return {
      information: {
        created: this.dateFormatService.stringToFullDateTime(siteForm.created),
        createdBy: siteForm.createdBy,
        updated: this.dateFormatService.stringToFullDateTime(siteForm.updated),
        updatedBy: siteForm.updatedBy,
      },
      commentsForm: {
        commentsBlog: siteForm.subscriptions[0] ? siteForm.subscriptions[0].comments : null,
        comments: ''
      }
    }
  }
  miscellaneousDbToFormMulti(siteForm: Site): MiscellaneousSiteForm {
    return {
      information: {
        created: this.dateFormatService.stringToFullDateTime(siteForm.created),
        createdBy: siteForm.createdBy,
        updated: this.dateFormatService.stringToFullDateTime(siteForm.updated),
        updatedBy: siteForm.updatedBy,
      },
      commentsForm: {
        commentsBlog: siteForm ? siteForm.comments : null,
        comments: ''
      }
    }
  }
  orderIsOpenFormMulti(siteForm: Site): boolean {
    return siteForm.subscriptions[0].isOrderOpened;
  }
  // tslint:disable-next-line:no-any
  formToDbMulti(api: string[], subForm: any): SubscriptionI {
    let newFormSite = null;
    switch (api[1]) {
      case 'site':
        newFormSite = this.siteToDBMulti(subForm);
        break;
      case 'subscription':
        newFormSite = this.subscriptionMultiToDB(subForm);
        break;
      case 'videoOption':
        newFormSite = this.videoOptionToDB(subForm);
        break;
      case 'commentsForm':
        newFormSite = this.commentsToDB(subForm);
        break;
      case 'address':
        newFormSite = this.addressToDB(subForm);
        break;
      case 'contact':
        newFormSite = this.contactToDB(subForm);
        break;
      case 'ipAddress':
        newFormSite = this.ipAddressToDB(subForm);
        break;
      case 'proxy':
        newFormSite = this.proxyToDB(subForm);
        break;
      case 'wifi':
        newFormSite = this.wifiToDB(subForm);
        break;
      case 'wifi':
        newFormSite = this.wifiToDB(subForm);
        break;
      case 'serverForm':
        newFormSite = this.serverToDB(subForm);
        break;
      case 'concepts':
        newFormSite = this.conceptsToDB(subForm);
        break;
      default:

        return subForm;
    }
    // tslint:disable-next-line:no-console
    return newFormSite;
  }

  // tslint:disable-next-line:no-any
  formToDb(api: string[], subForm: any): SubscriptionI {
    let newFormSite = null;
    switch (api[1]) {
      case 'site':
        newFormSite = this.siteToDB(subForm);
        break;
      case 'subscription':
        newFormSite = this.subscriptionToDB(subForm);
        break;
      case 'videoOption':
        newFormSite = this.videoOptionToDB(subForm);
        break;
      case 'commentsForm':
        newFormSite = this.commentsToDB(subForm);
        break;
      case 'address':
        newFormSite = this.addressToDB(subForm);
        break;
      case 'contact':
        newFormSite = this.contactToDB(subForm);
        break;
      case 'ipAddress':
        newFormSite = this.ipAddressToDB(subForm);
        break;
      case 'proxy':
        newFormSite = this.proxyToDB(subForm);
        break;
      case 'wifi':
        newFormSite = this.wifiToDB(subForm);
        break;
      case 'serverForm':
        newFormSite = this.serverToDB(subForm);
        break;
      case 'concepts':
        newFormSite = this.conceptsToDB(subForm);
        break;
      default:
        return subForm;
    }
    // tslint:disable-next-line:no-console
    return newFormSite;
  }

  // tslint:disable-next-line:no-any
  siteToDB(subForm: any): any {
    return {
      externalId: subForm.extId,
      timezone: subForm.timezone.ianaCode,
      cultures: subForm.cultures,
      displayName: subForm.displayName
    }
  }
  // tslint:disable-next-line:no-any
  siteToDBMulti(subForm: any): any {
    return {
      externalId: subForm.extId,
      timezone: subForm.timezone.ianaCode,
      displayName: subForm.displayName
    }
  }
  // tslint:disable-next-line:no-any
  subscriptionToDB(subForm: any): any {
    return {
      service: { id: subForm.service.id, name: subForm.service.id },
      status: subForm.status.id,
      product: { id: subForm.product.id, name: subForm.product.name },
      cultures: subForm.cultures,
      name: subForm.name,
      isSold: subForm.isSold,
      statutoryName: subForm.statutoryName,
    }
  }
  // tslint:disable-next-line:no-any
  subscriptionMultiToDB(subForm: any): any {
    return {
      service: { id: subForm.service.id, name: subForm.service.id },
      status: subForm.status.id,
      product: { id: subForm.product.id, name: subForm.product.name },
      cultures: subForm.cultures.code,
      name: subForm.name,
      isSold: subForm.isSold,
      statutoryName: subForm.statutoryName,
    }
  }
  // tslint:disable-next-line:no-any
  videoOptionToDB(subForm: any): any {
    return {
      screenRotation: subForm.screenRotation.id
    };
  }

  // tslint:disable-next-line:no-any
  commentsToDB(subForm: any): any {
    return {
      comments: subForm.comments
    };
  }

  // tslint:disable-next-line:no-any
  addressToDB(subForm: any): any {
    return {
      addressType: subForm.addressType.charAt(0).toUpperCase() + subForm.addressType.slice(1),
      checkBox: true,
      city: subForm.city,
      country: subForm.countryForm.name,
      id: subForm.id,
      line1: subForm.line1,
      line2: subForm.line2,
      line3: subForm.line3,
      name: subForm.name,
      state: subForm.state,
      uuid: subForm.uuid,
      zip: subForm.zip
    };
  }

  // tslint:disable-next-line:no-any
  contactToDB(subForm: any): any {
    return {
      email: subForm.email,
      id: subForm.id,
      name: subForm.name,
      phone: subForm.phone,
      surname: subForm.surname,
      uuid: subForm.uuid,
      mobile: subForm.mobile,
      department: subForm.department,
    };
  }

  // tslint:disable-next-line:no-any
  ipAddressToDB(subForm: any): any {
    return {
      dns1: subForm.ipAddress.dns1,
      dns2: subForm.ipAddress.dns2,
      gateway: subForm.ipAddress.gateway,
      mask: subForm.ipAddress.mask,
      ip: subForm.ipAddress.ip,
      isDhcp: subForm.ipAddress.isDhcp,
      id: subForm.ipAddress.id,
      uuid: subForm.ipAddress.uuid
    };
  }

  // tslint:disable-next-line:no-any
  proxyToDB(subForm: any): any {
    return {
      address: subForm.proxy.addressProxy,
      enable: subForm.proxy.addressProxy && subForm.proxy.port ? true : false,
      port: subForm.proxy.port,
    };
  }
  // tslint:disable-next-line:no-any
  serverToDB(subForm: any): any {
    return {
      id: subForm.server.id,
      name: subForm.name,
      ip: subForm.ip,
      url: subForm.url.id,
      cmsServerID: subForm.cms.id
    };
  }
  // tslint:disable-next-line:no-any
  conceptsToDB(subForm: any): any {
  return {
    concepts: subForm.concepts.id
  };
}
  // tslint:disable-next-line:no-any
  wifiToDB(subForm: any): any {
    return {
      id: subForm.wifi.id,
      ssid: subForm.wifi.ssid,
      uuid: subForm.wifi.uuid,
      security: {
        password: subForm.wifi.security_password,
        type: subForm.wifi.security_type ? subForm.wifi.security_type.code : null,
      },
      eap: {
        anonymous_identity: subForm.wifi.eap_anonymous_identity,
        ca_certificate: subForm.wifi.eap_ca_certificate,
        identity: subForm.wifi.eap_identity,
        methodName: subForm.wifi.eap_methodName ? subForm.wifi.eap_methodName.code : null,
        password: subForm.wifi.eap_password,
        phase_2_authentication: subForm.wifi.eap_phase_2_authentication ? subForm.wifi.eap_phase_2_authentication.code : null,
        user_certificate: subForm.wifi.eap_user_certificate,
      },
      enable: !!subForm.wifi.ssid,
    }
  }

}
